import adminApiClient from './api.admin';
import ADMIN_API_ENDPOINTS from './endpoints.admin';
class AdminArticlesService {
    async list(params) {
        return adminApiClient.get(ADMIN_API_ENDPOINTS.ARTICLES.BASE, params);
    }
    async listByParent(parentId) {
        return adminApiClient.get(ADMIN_API_ENDPOINTS.ARTICLES.BY_PARENT(parentId));
    }
    async get(id) {
        return adminApiClient.get(ADMIN_API_ENDPOINTS.ARTICLES.BY_ID(id));
    }
    async create(payload) {
        return adminApiClient.post(ADMIN_API_ENDPOINTS.ARTICLES.BASE, payload);
    }
    async update(id, payload) {
        // El endpoint de actualización usa POST, no PUT
        return adminApiClient.post(ADMIN_API_ENDPOINTS.ARTICLES.UPDATE(id), payload);
    }
    async remove(id) {
        return adminApiClient.delete(ADMIN_API_ENDPOINTS.ARTICLES.BY_ID(id));
    }
}
export const adminArticlesService = new AdminArticlesService();
export default adminArticlesService;
